module.exports = __webpack_public_path__ + "static/media/vvlogo.4530b174.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vvlogo.svg
// module id = 6854
// module chunks = 0